import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { HelpbuttonReportsFilterAssistancesCardComponent } from '../helpbutton-reports-filter-assistances-card/helpbutton-reports-filter-assistances-card.component';
import { ReportsHelpbuttonService } from '../../../services/helpbutton-services/reports-helpbutton-service/reports-helpbutton.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-helpbutton-reports-list-card',
  templateUrl: './helpbutton-reports-list-card.component.html',
  styleUrls: ['./helpbutton-reports-list-card.component.scss']
})
export class HelpbuttonReportsListCardComponent implements OnInit, OnChanges {

  @Input() data;
  tableData;
  customerEvaluationOrder;
  requestStatusOrder;
  centerNameOrder;
  customerNameOrder;
  staffNameOrder;
  departmentNameOrder;
  creationDateOrder;

  constructor(private reportsService: ReportsHelpbuttonService,
    private router: Router,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.wrapData();
  }

  ngOnChanges() {
    this.wrapData();
  }

  public wrapData() {
    if (this.data) {
      this.resetSortOrders();
      this.refreshCSVData();
    }
  }

  public resetSortOrders() {
    this.customerEvaluationOrder = 0;
    this.requestStatusOrder = 0;
    this.centerNameOrder = 0;
    this.customerNameOrder = 0;
    this.staffNameOrder = 0;
    this.departmentNameOrder = 0;
    this.creationDateOrder = 0;
  }

  public sortBy(attribute) {
    switch (attribute) {
      case 'customerEvaluation':
        this.customerEvaluationOrder = (this.customerEvaluationOrder === 0) ? 1 : (this.customerEvaluationOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.customerEvaluation = a.customerEvaluation ? a.customerEvaluation : ' ';
            b.customerEvaluation = b.customerEvaluation ? b.customerEvaluation : ' ';
            return (a.customerEvaluation.toUpperCase() < b.customerEvaluation.toUpperCase()) ? -this.customerEvaluationOrder : (a.customerEvaluation.toUpperCase() > b.customerEvaluation.toUpperCase()) ? this.customerEvaluationOrder : 0;
          });
        break;
      case 'requestStatus':
        this.requestStatusOrder = (this.requestStatusOrder === 0) ? 1 : (this.requestStatusOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.requestStatus = a.requestStatus ? a.requestStatus : ' ';
            b.requestStatus = b.requestStatus ? b.requestStatus : ' ';
            return (this.getStatus(a.requestStatus).toUpperCase() < this.getStatus(b.requestStatus).toUpperCase()) ? -this.requestStatusOrder : (this.getStatus(a.requestStatus).toUpperCase() > this.getStatus(b.requestStatus).toUpperCase()) ? this.requestStatusOrder : 0;
          });
        break;
      case 'centerName':
        this.centerNameOrder = (this.centerNameOrder === 0) ? 1 : (this.centerNameOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.sectionDto.centerDto.centerName = a.sectionDto.centerDto.centerName ? a.sectionDto.centerDto.centerName : ' ';
            b.sectionDto.centerDto.centerName = b.sectionDto.centerDto.centerName ? b.sectionDto.centerDto.centerName : ' ';
            return (a.sectionDto.centerDto.centerName.toUpperCase() < b.sectionDto.centerDto.centerName.toUpperCase()) ? -this.centerNameOrder : (a.sectionDto.centerDto.centerName.toUpperCase() > b.sectionDto.centerDto.centerName.toUpperCase()) ? this.centerNameOrder : 0;
          });
        break;
      case 'customerName':
        this.customerNameOrder = (this.customerNameOrder === 0) ? 1 : (this.customerNameOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.customerName = a.customerName ? a.customerName : ' ';
            b.customerName = b.customerName ? b.customerName : ' ';
            return (a.customerName.toUpperCase() < b.customerName.toUpperCase()) ? -this.customerNameOrder : (a.customerName.toUpperCase()) ? this.customerNameOrder : 0;
          });
        break;
      case 'staffName':
        this.staffNameOrder = (this.staffNameOrder === 0) ? 1 : (this.staffNameOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.assistanceEmployeeName = a.assistanceEmployeeName ? a.assistanceEmployeeName : ' ';
            b.assistanceEmployeeName = b.assistanceEmployeeName ? b.assistanceEmployeeName : ' ';
            return (a.assistanceEmployeeName.toUpperCase() < b.assistanceEmployeeName.toUpperCase()) ? -this.staffNameOrder : (a.assistanceEmployeeName.toUpperCase()) ? this.staffNameOrder : 0;
          });
        break;
      case 'departmentName':
        this.departmentNameOrder = (this.departmentNameOrder === 0) ? 1 : (this.departmentNameOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.sectionDto.sectionName = a.sectionDto.sectionName ? a.sectionDto.sectionName : ' ';
            b.sectionDto.sectionName = b.sectionDto.sectionName ? b.sectionDto.sectionName : ' ';
            return (a.sectionDto.sectionName.toUpperCase() < b.sectionDto.sectionName.toUpperCase()) ? -this.departmentNameOrder : (a.sectionDto.sectionName.toUpperCase()) ? this.departmentNameOrder : 0;
          });
        break;
        case 'creationDate':
        this.creationDateOrder = (this.creationDateOrder === 0) ? 1 : (this.creationDateOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.creationDate = a.creationDate ? a.creationDate : ' ';
            b.creationDate = b.creationDate ? b.creationDate : ' ';
            return (a.creationDate < b.creationDate) ? -this.creationDateOrder : (a.creationDate) ? this.creationDateOrder : 0;
          });
        break;
    }
    this.refreshCSVData();
  }

  public getStatus(status) {
    switch (status) {
      case 'OPEN':
        return 'WAITING';
      case 'IN_ASSISTANCE':
        return 'ATTENDING';
      case 'CLOSED':
        return 'CLOSED';
      case 'CANCELLED':
        return 'ABORTED';
      case 'CANCELLED_AUTOMATICALLY':
        return 'IGNORED';
    }
  }
  public getCustomerEvaluationIcon(customerEvaluation) {
    switch (customerEvaluation) {
      case 'BAD':
        return 'far fa-frown';
      case 'NEUTRAL':
        return 'far fa-meh';
      case 'GOOD':
        return 'far fa-smile';
    }
  }

  public refreshCSVData() {
    this.reportsService.refreshFormattedAssistancesList(this.data);
  }

  public gotoDetail(assistanceId) {
    this.router.navigate(['../../report/' + assistanceId], { relativeTo: this.activatedRoute });
  }

}
